@if (form; as form) {
  <fieldset [formGroup]="form">
    <legend>
      Rodzaj urządzenia
    </legend>
    <div class="row">
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"deviceType" as controlName'>
          <label [for]='controlName'>
            Rodzaj *
          </label>
          <input
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu rodzaj urządzenia'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
  </fieldset>
  <fieldset [formGroup]="form">
    <legend>
      Rodzaj elementu pasa drogowego
    </legend>
    <div class="row">
      <div class="col-md-3">
        <div class='form-group' *ngIf='"roadwayWidth" as controlName'>
          <label [for]='controlName'>
            Szerokość jezdni (m)
          </label>
          <input
            (change)="form.calcRoadwayArea()"
            mask='separator.2'
            decimalMarker=','
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu szerokość'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-md-3">
        <div class='form-group' *ngIf='"roadwayLength" as controlName'>
          <label [for]='controlName'>
            Długość jezdni (m)
          </label>
          <input
            (change)="form.calcRoadwayArea()"
            mask='separator.2'
            decimalMarker=','
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu długość'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-md-3">
        <div class='form-group' *ngIf='"roadwayArea" as controlName'>
          <label [for]='controlName'>
            Powierzchnia jezdni (m<sup>2</sup>)
          </label>
          <input
            mask='separator.2'
            decimalMarker=','
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class='form-group' *ngIf='"sidewalkWidth" as controlName'>
          <label [for]='controlName'>
            Szerokość chodników, zatok postojowych, ścieżek rowerowych (m)
          </label>
          <input
            (change)="form.calcSidewalkArea()"
            mask='separator.2'
            decimalMarker=','
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu szerokość'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-md-3">
        <div class='form-group' *ngIf='"sidewalkLength" as controlName'>
          <label [for]='controlName'>
            Długość chodników, zatok postojowych, ścieżek rowerowych (m)
          </label>
          <input
            (change)="form.calcSidewalkArea()"
            mask='separator.2'
            decimalMarker=','
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu długość'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-md-3">
        <div class='form-group' *ngIf='"sidewalkArea" as controlName'>
          <label [for]='controlName'>
            Powierzchnia chodników, zatok postojowych, ścieżek rowerowych (m<sup>2</sup>)
          </label>
          <input
            mask='separator.2'
            decimalMarker=','
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class='form-group' *ngIf='"remainingElementsWidth" as controlName'>
          <label [for]='controlName'>
            Szerokość pozostałych elementów pasa drogowego (pobocza, rowu, pasa zieleni) (m)
          </label>
          <input
            (change)="form.calcRemainingElementsArea()"
            mask='separator.2'
            decimalMarker=','
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu szerokość'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-md-3">
        <div class='form-group' *ngIf='"remainingElementsLength" as controlName'>
          <label [for]='controlName'>
            Długość pozostałych elementów pasa drogowego (pobocza, rowu, pasa zieleni) (m)
          </label>
          <input
            (change)="form.calcRemainingElementsArea()"
            mask='separator.2'
            decimalMarker=','
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu długość'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-md-3">
        <div class='form-group' *ngIf='"remainingElementsArea" as controlName'>
          <label [for]='controlName'>
            Powierzchnia pozostałych elementów pasa drogowego (pobocza, rowu, pasa zieleni) (m<sup>2</sup>)
          </label>
          <input
            mask='separator.2'
            decimalMarker=','
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class='form-group' *ngIf='"bridgeStructureWidth" as controlName'>
          <label [for]='controlName'>
            Szerokość zajęcia na obiekcie mostowym (m)
          </label>
          <input
            (change)="form.calcBridgeStructureArea()"
            mask='separator.2'
            decimalMarker=','
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu szerokość'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-md-3">
        <div class='form-group' *ngIf='"bridgeStructureLength" as controlName'>
          <label [for]='controlName'>
            Długość zajęcia na obiekcie mostowym (m)
          </label>
          <input
            (change)="form.calcBridgeStructureArea()"
            mask='separator.2'
            decimalMarker=','
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu długość'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-md-3">
        <div class='form-group' *ngIf='"bridgeStructureArea" as controlName'>
          <label [for]='controlName'>
            Powierzchnia zajęcia na obiekcie mostowym (m<sup>2</sup>)
          </label>
          <input
            mask='separator.2'
            decimalMarker=','
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
  </fieldset>
  <fieldset [formGroup]="form">
    <legend>
      Termin umieszczenia
    </legend>
    <div class="row">
      <div class="col-md-4">
        <div class='form-group' *ngIf='"placementDate" as controlName'>
          <label [for]='controlName'>
            Od dnia *
          </label>
          <app-date-picker [id]='controlName' [formControlName]='controlName'>
          </app-date-picker>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
  </fieldset>
}
